import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  companyInfo: null,
  loading: false,
  error: null,
};

const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    setCompanyInfo: (state, action) => {
      state.companyInfo = action.payload;
      state.loading = false;
      state.error = null;
    },
    clearCompanyInfo: (state) => {
      state.companyInfo = null;
      state.loading = false;
      state.error = null;
    },
    setCompanyLoading: (state, action) => {
      state.loading = action.payload;
    },
    setCompanyError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const { 
  setCompanyInfo, 
  clearCompanyInfo, 
  setCompanyLoading, 
  setCompanyError 
} = companySlice.actions;

export const selectCompanyInfo = (state) => state.company.companyInfo;
export const selectCompanyLoading = (state) => state.company.loading;
export const selectCompanyError = (state) => state.company.error;

export default companySlice.reducer;